var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6fabe6;}.cls-2{fill:#82bcf4;}.cls-3{fill:#edb996;}.cls-4{fill:#f6ccaf;}.cls-5{fill:#fc6;}.cls-6{fill:#ffde76;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Top rating feedback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Top_rating_feedback",
    "data-name": "Top rating feedback"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8,
    y: 31,
    width: 8,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,32c0,13.72-.1,13,0,13a5,5,0,0,1-5-5V31h4A1,1,0,0,1,16,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.22,31H28l1.43-5.61c.55-3.28-4.1-4.71-4.81-1.88C23.47,28.11,22.54,28.46,19,32l-3,1V46h2.42c2.79,0,3.37,1,6.16,1h8.64a3.55,3.55,0,0,0,3.45-2.7l2.22-8.87A3.6,3.6,0,0,0,35.22,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.89,35.43c-2.43,9.71-2.23,9.68-3.25,10.62a3.61,3.61,0,0,0,.88-1.31,3.5,3.5,0,0,1-1.3.26c-9.16,0-9.54.18-11.88-.55A9.64,9.64,0,0,0,20.42,44,2.42,2.42,0,0,1,18,41.58V32.33L19,32c2.62-2.62,4.47-3.9,5.37-7.49.25-1,.45-2.42,2-2.51a2.92,2.92,0,0,1,3,3.39L28,31h7.22A3.59,3.59,0,0,1,38.89,35.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.5,22a2,2,0,0,0-1.88,1.5,10.79,10.79,0,0,1-2.81,5.7C24.52,26.59,25.6,25.61,26.5,22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "24 1 25.3 3.63 28.21 4.06 26.1 6.11 26.6 9 24 7.63 21.4 9 21.9 6.11 19.79 4.06 22.7 3.63 24 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "24 1 25.3 3.63 28.21 4.06 26.1 6.11 26.6 9 24 7.63 21.4 9 21.9 6.11 19.79 4.06 22.7 3.63 24 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "34 8 35.3 10.63 38.21 11.06 36.1 13.11 36.6 16 34 14.63 31.4 16 31.9 13.11 29.79 11.06 32.7 10.63 34 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "42.79 16 44.09 18.63 47 19.06 44.9 21.11 45.39 24 42.79 22.63 40.2 24 40.69 21.11 38.59 19.06 41.49 18.63 42.79 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "14 8 12.7 10.63 9.79 11.06 11.9 13.11 11.4 16 14 14.63 16.6 16 16.1 13.11 18.21 11.06 15.3 10.63 14 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "5.21 16 3.91 18.63 1 19.06 3.1 21.11 2.61 24 5.21 22.63 7.8 24 7.31 21.11 9.41 19.06 6.51 18.63 5.21 16"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingIcon);
export default __webpack_public_path__ + "static/media/rating-icon.89565249f1378c3b41203d9251070aad.svg";
export { ForwardRef as ReactComponent };